/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo, useState } from "react";
import { isNil } from "ramda";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/terminal/types";
import { deleteRequest as deleteTerminal } from "../../../store/terminal/actions";
import TableActions from "../../../common/table/TableActions";
import { MRT_ColumnDef, MaterialReactTable } from "material-react-table";

interface Props {
  terminal?: Data[];
}

interface RowData {
  id: string;
  terminalType?: string;
  serNo?: string;
  manufacturer?: string;
  model?: string;
  selected: boolean;
}

const mapDataToTable = (terminal: Data[]): RowData[] => {
  return terminal.map((data) => {
    return {
      id: data.id,
      terminalType: data.attributes.TerminalType,
      serNo: data.attributes.SerNo,
      manufacturer: data.attributes.Manufacturer,
      model: data.attributes.Model,
      selected: data.selected || false,
    };
  });
};

export default function TerminalTable({ terminal }: Props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showConfirm, setShowConfirm] = useState(false);
  const [currentId, setCurrentId] = useState<string | null>(null);

  const editAction = (rowData: RowData) => {
    history.push(`/terminal/edit/${rowData.id}`);
  };

  const deleteAction = (rowData: RowData) => {
    setCurrentId(rowData.id);
    setShowConfirm(true);
  };

  const deleteConfirmationHandler = () => {
    const callback = (error: string | null) => {
      if (error) {
        console.log(error);
      }
    };
    !isNil(currentId) && dispatch(deleteTerminal(currentId, callback));
    setCurrentId(null);
    setShowConfirm(false);
  };

  const data = mapDataToTable(terminal);

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      { header: "Terminal Type", accessorKey: "terminalType" },
      { header: "Ser No", accessorKey: "serNo" },
      { header: "Manufacturer", accessorKey: "manufacturer" },
      { header: "Model", accessorKey: "model" },
    ],
    []
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      getRowId={(row) => row.id}
      initialState={{
        showColumnFilters: false,
        density: "spacious",
      }}
      enableColumnActions={false}
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      enableColumnFilters={false}
      enableHiding={false}
      enableRowActions
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "",
          size: 100,
        },
      }}
      positionActionsColumn="last"
      renderRowActions={({ row }) => (
        <TableActions
          section="Terminal"
          onEdit={() => editAction(row.original)}
          onDelete={() => deleteAction(row.original)}
        />
      )}
    />
  );
}
